// extracted by mini-css-extract-plugin
export default {"section":"SectionWrapper_section__VKyQA","sectionTitle":"SectionWrapper_sectionTitle__ioE1s"};